// Import images
import PlatformAdmin from './PlatformAdmin.png';
import PlatformAdmin2 from './PlatformAdmin2.png';
import PlatformAppBuilder from './PlatformAppBuilder.png';
import PlatformBusinessAnalsyt from './PlatformBusinessAnalyst.png';

// Map certification names to images
const certMap = {
  "Salesforce Certified Platform Administrator": PlatformAdmin,
  "Salesforce Certified Platform App Builder": PlatformAppBuilder,
  "Salesforce Certified Business Analyst": PlatformBusinessAnalsyt,
  "Salesforce Certified Platform Administrator II": PlatformAdmin2,
};

// Export both the map and a default
export { certMap };